import { Injectable } from '@angular/core';
import { LoginEvent, LogoutEvent, Query, QueryService, UserIdService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { User } from '../../../profile/root';
import { UserAccountChangedEvent, UserAccountFacade } from '../../root';
import { UserAccountConnector } from '../connectors/user-account.connector';

@Injectable()
export class UserAccountService implements UserAccountFacade {
  protected userQuery: Query<User> = this.query.create(
    () => this.userIdService.takeUserId(true).pipe(switchMap(() => this.userAccountConnector.get())),
    {
      reloadOn: [UserAccountChangedEvent],
      resetOn: [LoginEvent, LogoutEvent],
    },
  );

  constructor(
    protected userAccountConnector: UserAccountConnector,
    protected userIdService: UserIdService,
    protected query: QueryService,
  ) {}

  /**
   * Returns the current user.
   */
  get(): Observable<User | undefined> {
    return this.userQuery.get();
  }
}
